
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("lFyOr", function(module, exports) {
/* ListenByline.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $afBrg = parcelRequire("afBrg");


var $3gadb = parcelRequire("3gadb");


var $fVUfS = parcelRequire("fVUfS");


var $dcJ7R = parcelRequire("dcJ7R");


var $c6lAS = parcelRequire("c6lAS");


var $hmWxM = parcelRequire("hmWxM");


var $dczXc = parcelRequire("dczXc");


var $dWpd3 = parcelRequire("dWpd3");

const $57ff6b5292784cf1$var$i18n = (0, $aXWIB.defineMessages)({
    listen: {
        id: "audio.listen-byline.listen",
        defaultMessage: "Listen"
    }
});
const $57ff6b5292784cf1$var$wrapperStyles = null;
const $57ff6b5292784cf1$export$aeb07f2d59756a1b = ({ contentId: contentId, contentType: contentType, playImmediately: playImmediately = false })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { data: data } = (0, $dczXc.useAudioContentQuery)({
        contentId: contentId
    });
    const { setActiveContent: setActiveContent } = (0, $dWpd3.useAudioButtonWrapperActions)();
    const activeContent = (0, $hmWxM.useActiveContent)({
        contentId: contentId,
        contentType: contentType ?? 'page',
        data: data
    });
    (0, $42omo.useEffect)(()=>{
        setActiveContent(activeContent);
    }, [
        activeContent,
        setActiveContent
    ]);
    const { handleClick: handleClick, isAudioSupported: isAudioSupported, tooltipContent: tooltipContent, buttonRef: buttonRef } = (0, $c6lAS.useAudioListenTrigger)({
        activeContent: activeContent,
        source: 'byLine',
        isAutoOpenDisabled: !data?.singleContent,
        playImmediately: playImmediately
    });
    const handleHover = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'byLine',
                action: 'hovered',
                actionSubject: 'button',
                actionSubjectId: 'byLineListen',
                attributes: {
                    contentType: contentType
                }
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        className: (0, $gMc0m.default)([
            "_1e0c116y _4cvr1h6o _12l21b66 _4t3i1tcg _zs1212b0 _7dirsm61 _d32vazsu _11lv1b66 _yhjm1b66 _1gfl1b66 _1gqn1b66 _6pup1dpa"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: tooltipContent,
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        ref: buttonRef,
        onClick: handleClick,
        onMouseEnter: handleHover,
        onFocus: handleHover,
        isDisabled: !isAudioSupported,
        testId: "byline-listen"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($afBrg))), {
        label: ""
    }), formatMessage($57ff6b5292784cf1$var$i18n.listen)))));
};
module.exports["ListenByline"] = $57ff6b5292784cf1$export$aeb07f2d59756a1b;

});

parcelRegister("afBrg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::28e818db41afcf6fce742cecb9d4361e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $776858abadb4b212$var$_react = $776858abadb4b212$var$_interopRequireDefault((parcelRequire("42omo")));

var $776858abadb4b212$var$_baseNew = $776858abadb4b212$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $776858abadb4b212$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeAudioBriefing".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Audio Briefings, a new feature launching within Confluence to help people develop an expanded awareness on a topic by generating AI-powered podcasts about their work.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $776858abadb4b212$var$AiGenerativeAudioBriefingIcon = (props)=>/*#__PURE__*/ $776858abadb4b212$var$_react.default.createElement($776858abadb4b212$var$_baseNew.default, Object.assign({
        name: "AiGenerativeAudioBriefingIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0c.97 0 1.88.2 2.72.55l-.24.09c-.52.19-.93.56-1.19 1.02A5.5 5.5 0 0 0 2.5 7v.71A2.5 2.5 0 0 1 6 10v3.08A1.92 1.92 0 0 1 4.08 15 3.08 3.08 0 0 1 1 12V7a7 7 0 0 1 7-7M3.5 9a1 1 0 0 0-1 1v1.92c0 .87.71 1.58 1.58 1.58.23 0 .42-.19.42-.42V10a1 1 0 0 0-1-1m11.46-2.78Q15 6.6 15 7v5a3.08 3.08 0 0 1-3.08 3A1.92 1.92 0 0 1 10 13.08V10a2.5 2.5 0 0 1 3.5-2.29v-.73a2.25 2.25 0 0 0 1.46-.77M12.5 9a1 1 0 0 0-1 1v3.08c0 .23.19.42.42.42.87 0 1.58-.71 1.58-1.58V10a1 1 0 0 0-1-1" clip-rule="evenodd"/><path fill="currentcolor" d="M13.365.009a.75.75 0 0 1 .541.378l.05.106.334.92a.5.5 0 0 0 .298.297l.919.335a.75.75 0 0 1 0 1.41l-.92.335a.5.5 0 0 0-.297.298l-.335.919a.75.75 0 0 1-1.41 0l-.335-.92a.5.5 0 0 0-.298-.297l-.919-.335a.75.75 0 0 1-.484-.589L10.5 2.75l.009-.116a.75.75 0 0 1 .484-.59l.92-.334a.5.5 0 0 0 .297-.298l.335-.919A.75.75 0 0 1 13.249 0z"/>`
    }, props));
$776858abadb4b212$var$AiGenerativeAudioBriefingIcon.displayName = 'AiGenerativeAudioBriefingIcon';
var $776858abadb4b212$var$_default = module.exports.default = $776858abadb4b212$var$AiGenerativeAudioBriefingIcon;

});

parcelRegister("c6lAS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $hTKp4 = parcelRequire("hTKp4");


var $dxfEr = parcelRequire("dxfEr");


var $aDFyc = parcelRequire("aDFyc");


var $9s8in = parcelRequire("9s8in");


var $4wsPv = parcelRequire("4wsPv");


var $i0AAn = parcelRequire("i0AAn");


var $aU1TP = parcelRequire("aU1TP");

const $d8ee606bcf5d4a13$var$i18n = (0, $aXWIB.defineMessages)({
    listen: {
        id: "audio.audio-player.audio-listen-button.listen",
        defaultMessage: "Listen"
    },
    listenToContent: {
        id: "audio.audio-player.audio-listen-button.listen",
        defaultMessage: "Listen to {contentType}"
    },
    browserNotSupported: {
        id: "audio.audio-player.audio-listen-button.browserNotSupported",
        defaultMessage: "Your browser doesn\u2019t support this feature"
    },
    contentTypePage: {
        id: "audio.audio-player.audio-listen-button.contentTypePage",
        defaultMessage: "page"
    },
    contentTypeBlogPost: {
        id: "audio.audio-player.audio-listen-button.contentTypeBlogPost",
        defaultMessage: "blogpost"
    },
    contentTypeLiveDoc: {
        id: "audio.audio-player.audio-listen-button.contentTypeLiveDoc",
        defaultMessage: "live doc"
    }
});
const $d8ee606bcf5d4a13$export$c02d0b9fb316ce5a = ({ activeContent: activeContent, source: source, isDisabled: isDisabled = false, isAutoOpenDisabled: isAutoOpenDisabled = false, playImmediately: playImmediately = false })=>{
    // Assume audio is enabled for SSR until client side useEffect checks browser support.
    // This is to avoid expensive hydration issues since in most cases audio will indeed be supported.
    const [audioSupportedByBrowser, setAudioSupportedByBrowser] = (0, $42omo.useState)(true);
    const { formatMessage: formatMessage, locale: locale } = (0, $aXWIB.useIntl)();
    const { sendUIEvent: sendUIEvent, sendScreenEvent: sendScreenEvent } = (0, $dxfEr.usePlatformInstrumentation)();
    const buttonRef = (0, $42omo.useRef)(null);
    const { openAudioPlayer: openAudioPlayer, isOpen: isOpen } = (0, $9s8in.useAudioPlayerStore)();
    const { state: streamingState } = (0, $4wsPv.useAudioPlayerStreamingStore)();
    const isUninitialized = streamingState.state === (0, $aU1TP.AudioStreamingState).UNINITIALIZED;
    // Handle audio share links from URL parameters
    (0, $i0AAn.useAudioShareLink)(activeContent, isUninitialized, isAutoOpenDisabled);
    // Check browser capability for audio support
    (0, $42omo.useEffect)(()=>{
        const isAudioSupportedByBrowser = typeof MediaSource !== 'undefined' && MediaSource.isTypeSupported('audio/mpeg');
        if (!isAudioSupportedByBrowser) {
            setAudioSupportedByBrowser(false);
            sendScreenEvent({
                eventType: 'screen',
                name: 'audioButtonDisabled',
                attributes: {
                    source: source,
                    locale: locale,
                    version: 'v3'
                }
            });
        } else sendScreenEvent({
            eventType: 'screen',
            name: 'audioButton',
            attributes: {
                source: source,
                locale: locale,
                version: 'v3'
            }
        });
    }, [
        sendScreenEvent,
        locale,
        source
    ]);
    const sendAnalyticsUIEvent = (0, $42omo.useCallback)((action)=>{
        sendUIEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'audioPopup',
            source: source,
            attributes: {
                action: action,
                contentType: activeContent.contentType ?? 'page'
            }
        });
    }, [
        sendUIEvent,
        activeContent,
        source
    ]);
    const handleClick = (0, $42omo.useCallback)(()=>{
        if (!isOpen) sendAnalyticsUIEvent('openPopup');
        // When rendered inside an embedded iframe (e.g. a smart-link embed), the audio player lives in the parent frame.
        // Send a postMessage so the parent can open its own AudioContainer.
        // Note, `returnFocusRef` is intentionally excluded since it cannot be serialized by postMessage.
        if (window.parent !== window) {
            const document = (0, $hTKp4.getDocument)();
            if (!document) return;
            const targetOrigin = document.referrer ? new URL(document.referrer).origin : '*';
            window.parent.postMessage({
                type: (0, $aDFyc.AUDIO_PLAYER_OPEN_REQUEST),
                activeContent: activeContent,
                options: {
                    isUninitialized: isUninitialized,
                    playImmediately: playImmediately
                }
            }, targetOrigin);
            return;
        }
        openAudioPlayer(activeContent, {
            isUninitialized: isUninitialized,
            returnFocusRef: buttonRef,
            playImmediately: playImmediately
        });
    }, [
        isOpen,
        sendAnalyticsUIEvent,
        openAudioPlayer,
        activeContent,
        isUninitialized,
        playImmediately
    ]);
    const contentTypeMessages = {
        live: $d8ee606bcf5d4a13$var$i18n.contentTypeLiveDoc,
        page: $d8ee606bcf5d4a13$var$i18n.contentTypePage,
        blogpost: $d8ee606bcf5d4a13$var$i18n.contentTypeBlogPost
    };
    const key = activeContent.subType || activeContent.contentType;
    const contentTypeMessage = key ? contentTypeMessages[key] : undefined;
    const contentType = contentTypeMessage ? formatMessage(contentTypeMessage) : '';
    const label = contentType ? formatMessage($d8ee606bcf5d4a13$var$i18n.listenToContent, {
        contentType: contentType
    }) : formatMessage($d8ee606bcf5d4a13$var$i18n.listen);
    const tooltipContent = audioSupportedByBrowser ? label : formatMessage($d8ee606bcf5d4a13$var$i18n.browserNotSupported);
    return {
        handleClick: handleClick,
        isAudioSupported: !isDisabled && audioSupportedByBrowser,
        tooltipContent: tooltipContent,
        buttonRef: buttonRef,
        label: label
    };
};
module.exports["useAudioListenTrigger"] = $d8ee606bcf5d4a13$export$c02d0b9fb316ce5a;

});

parcelRegister("aDFyc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9s8in = parcelRequire("9s8in");

const $2d668387d97f8250$export$c4a6bbd66a3ec4f3 = 'AUDIO_PLAYER_OPEN_REQUEST';
const $2d668387d97f8250$var$isAudioPlayerIframeMessage = (data)=>{
    if (!data || typeof data !== 'object') return false;
    const message = data;
    return message.type === $2d668387d97f8250$export$c4a6bbd66a3ec4f3 && message.activeContent != null;
};
const $2d668387d97f8250$export$ce895abfddbf56a4 = ()=>{
    const { openAudioPlayer: openAudioPlayer } = (0, $9s8in.useAudioPlayerStore)();
    (0, $42omo.useEffect)(()=>{
        const handleMessage = (event)=>{
            if (!$2d668387d97f8250$var$isAudioPlayerIframeMessage(event.data)) return;
            openAudioPlayer(event.data.activeContent, event.data.options);
        };
        window.addEventListener('message', handleMessage);
        return ()=>{
            window.removeEventListener('message', handleMessage);
        };
    }, [
        openAudioPlayer
    ]);
};
module.exports["AUDIO_PLAYER_OPEN_REQUEST"] = $2d668387d97f8250$export$c4a6bbd66a3ec4f3;
module.exports["useAudioPlayerIframeListener"] = $2d668387d97f8250$export$ce895abfddbf56a4;

});

parcelRegister("4wsPv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lbhE8 = parcelRequire("lbhE8");


var $aU1TP = parcelRequire("aU1TP");

const $441d910c6d0db13d$export$9ea8ebe6968f73b1 = ()=>{
    const state = (0, $lbhE8.useAtom)((0, $aU1TP.audioPlayerStreamingStore));
    const updateAudioPlayerStreamingStore = (0, $42omo.useCallback)((action)=>{
        (0, $aU1TP.setAudioPlayerStreamingStore)(action);
    }, []);
    return {
        state: state,
        updateAudioPlayerStreamingStore: updateAudioPlayerStreamingStore
    };
};
module.exports["useAudioPlayerStreamingStore"] = $441d910c6d0db13d$export$9ea8ebe6968f73b1;

});

parcelRegister("aU1TP", function(module, exports) {

var $9TRAA = parcelRequire("9TRAA");

var $ae4e7949267550f2$export$eb3237121301a5e5 = /*#__PURE__*/ function(AudioStreamingState) {
    AudioStreamingState["UNINITIALIZED"] = "uninitialized";
    AudioStreamingState["LOADING"] = "loading";
    AudioStreamingState["ERROR"] = "error";
    AudioStreamingState["STREAM_STARTED"] = "stream_started";
    AudioStreamingState["STREAM_DISPOSED"] = "stream_disposed";
    return AudioStreamingState;
}({});
const $ae4e7949267550f2$export$a0ed58682f50d27c = (0, $9TRAA.e)({
    state: "uninitialized"
});
const $ae4e7949267550f2$export$218145c33c4aee2e = (action)=>{
    switch(action.type){
        case "uninitialized":
            $ae4e7949267550f2$export$a0ed58682f50d27c.set({
                state: "uninitialized"
            });
            break;
        case "loading":
            $ae4e7949267550f2$export$a0ed58682f50d27c.set({
                state: "loading"
            });
            break;
        case "error":
            $ae4e7949267550f2$export$a0ed58682f50d27c.set({
                state: "error",
                error: action.error
            });
            break;
        case "stream_started":
            $ae4e7949267550f2$export$a0ed58682f50d27c.set({
                state: "stream_started",
                response: action.response
            });
            break;
        case "stream_disposed":
            $ae4e7949267550f2$export$a0ed58682f50d27c.set({
                state: "stream_disposed"
            });
            break;
    }
};
module.exports["AudioStreamingState"] = $ae4e7949267550f2$export$eb3237121301a5e5;
module.exports["audioPlayerStreamingStore"] = $ae4e7949267550f2$export$a0ed58682f50d27c;
module.exports["setAudioPlayerStreamingStore"] = $ae4e7949267550f2$export$218145c33c4aee2e;

});

parcelRegister("i0AAn", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dxfEr = parcelRequire("dxfEr");


var $eq3pJ = parcelRequire("eq3pJ");


var $9s8in = parcelRequire("9s8in");

const $1a207dac82daf856$export$569f1a6cc6f4247f = (activeContent, isUninitialized, isDisabled)=>{
    const { setActiveFeature: setActiveFeature, openAudioPlayer: openAudioPlayer } = (0, $9s8in.useAudioPlayerStore)();
    const { sendUIEvent: sendUIEvent } = (0, $dxfEr.usePlatformInstrumentation)();
    const currentSearch = window.location.search;
    (0, $42omo.useEffect)(()=>{
        if (isDisabled) return;
        const audioShareParam = new URLSearchParams(currentSearch).get('audioShare');
        if (!audioShareParam) return;
        const { feature: feature, supportingContent: supportingContent } = (0, $eq3pJ.parseAudioShareLink)(window.location.href);
        setActiveFeature(feature);
        openAudioPlayer({
            ...activeContent,
            supportingContent: supportingContent
        }, {
            isUninitialized: isUninitialized
        });
        sendUIEvent({
            eventType: 'ui',
            action: 'opened',
            actionSubject: 'aiAudioShareLink',
            attributes: {
                contentType: activeContent.contentType,
                trackType: feature
            }
        });
        const url = new URL(window.location.href);
        url.searchParams.delete('audioShare');
        window.history.replaceState({}, '', url.toString());
    }, [
        setActiveFeature,
        openAudioPlayer,
        sendUIEvent,
        activeContent,
        isDisabled,
        isUninitialized,
        currentSearch
    ]);
};
module.exports["useAudioShareLink"] = $1a207dac82daf856$export$569f1a6cc6f4247f;

});

parcelRegister("eq3pJ", function(module, exports) {

var $6otn0 = parcelRequire("6otn0");


var $CAM5Y = parcelRequire("CAM5Y");


var $5vJ4Q = parcelRequire("5vJ4Q");


var $iA9co = parcelRequire("iA9co");

var $93a7a8b84b793666$require$Buffer = $iA9co.Buffer;
const $93a7a8b84b793666$var$generateAudioSharePayload = (feature, supportingContent)=>{
    if (feature === (0, $CAM5Y.AudioFeatureType).BRIEFING) return supportingContent.map((content)=>`${content.ari},${content.link}`).join(',');
    return '';
};
const $93a7a8b84b793666$var$generateCompressedAndEncodedAudioShareValue = (feature, supportingContent)=>{
    const payload = $93a7a8b84b793666$var$generateAudioSharePayload(feature, supportingContent);
    const audioShareValue = `feature=${feature};type=${(0, $5vJ4Q.AudioSharingVersion).V1};payload=${payload}`;
    const compressedAudioShareValue = (0, $6otn0.gzipSync)(new TextEncoder().encode(audioShareValue));
    return $93a7a8b84b793666$require$Buffer.from(compressedAudioShareValue).toString('base64');
};
const $93a7a8b84b793666$export$74cf488b6935d40f = (mainSourceUrl, feature, supportingContent)=>{
    const url = new URL(mainSourceUrl);
    const audioShareValue = $93a7a8b84b793666$var$generateCompressedAndEncodedAudioShareValue(feature, supportingContent);
    url.searchParams.set('audioShare', audioShareValue);
    return url.toString();
};
const $93a7a8b84b793666$var$parseAudioSharePayload = (payload)=>{
    const combinedSources = payload.split(',').filter(Boolean);
    if (combinedSources.length % 2 !== 0) return [];
    const supportingContent = [];
    for(let i = 0; i < combinedSources.length; i += 2)supportingContent.push({
        ari: combinedSources[i],
        link: combinedSources[i + 1]
    });
    return supportingContent;
};
const $93a7a8b84b793666$var$decompressAudioShareValue = (encodedValue)=>{
    try {
        const compressedArray = Uint8Array.from($93a7a8b84b793666$require$Buffer.from(encodedValue, 'base64'));
        const decompressedArray = (0, $6otn0.gunzipSync)(compressedArray);
        const audioShareValue = new TextDecoder().decode(decompressedArray);
        const entries = audioShareValue.split(';').map((part)=>part.split('='));
        const data = Object.fromEntries(entries);
        return {
            feature: data.feature || '',
            type: data.type || '',
            payload: data.payload || ''
        };
    } catch  {
        return null;
    }
};
const $93a7a8b84b793666$export$74d89d4e604f8429 = (audioShareLink)=>{
    const defaultResult = {
        feature: (0, $CAM5Y.AudioFeatureType).BRIEFING,
        supportingContent: []
    };
    try {
        const url = new URL(audioShareLink);
        const encodedValue = url.searchParams.get('audioShare');
        if (!encodedValue) return defaultResult;
        const parsedData = $93a7a8b84b793666$var$decompressAudioShareValue(encodedValue);
        if (!parsedData) return defaultResult;
        if (parsedData.type !== (0, $5vJ4Q.AudioSharingVersion).V1) return {
            feature: parsedData.feature || (0, $CAM5Y.AudioFeatureType).BRIEFING,
            supportingContent: []
        };
        return {
            feature: parsedData.feature || (0, $CAM5Y.AudioFeatureType).BRIEFING,
            supportingContent: $93a7a8b84b793666$var$parseAudioSharePayload(parsedData.payload)
        };
    } catch  {
        return defaultResult;
    }
};
module.exports["generateAudioShareLink"] = $93a7a8b84b793666$export$74cf488b6935d40f;
module.exports["parseAudioShareLink"] = $93a7a8b84b793666$export$74d89d4e604f8429;

});

parcelRegister("5vJ4Q", function(module, exports) {
const $506afddc853935f8$export$c944456865027afe = {
    V1: '1'
};
module.exports["AudioSharingVersion"] = $506afddc853935f8$export$c944456865027afe;

});

parcelRegister("hmWxM", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $huWyw = parcelRequire("huWyw");

const $aa7b9d34cae35fec$export$73b9d3ccb27217c5 = ({ contentId: contentId, contentType: contentType, spaceKey: spaceKey = '', data: data, title: currentTitle })=>{
    const title = currentTitle || data?.singleContent?.title;
    const ownerName = data?.singleContent?.history?.ownedBy?.displayName;
    const authorName = data?.singleContent?.history?.createdBy?.displayName;
    const ownerAvatarUrl = data?.singleContent?.history?.ownedBy?.profilePicture?.path;
    const authorAvatarUrl = data?.singleContent?.history?.createdBy?.profilePicture?.path;
    const baseLink = data?.singleContent?.links?.base || '';
    const webuiLink = data?.singleContent?.links?.webui || '';
    const shouldUsePageOwner = ownerName && contentType === 'page';
    const contentAvatarName = shouldUsePageOwner ? ownerName : authorName;
    const contentAvatarUrl = shouldUsePageOwner ? ownerAvatarUrl : authorAvatarUrl;
    const editorVersion = data?.singleContent?.properties?.nodes?.find((prop)=>prop?.key === 'editor')?.value?.replace(/['"]+/g, '');
    const mainContentLink = (0, $42omo.useMemo)(()=>{
        return editorVersion === 'v2' ? baseLink + (0, $huWyw.getURLBypassingResumeDraftAction)({
            url: webuiLink,
            spaceKey: spaceKey,
            contentType: contentType,
            editorVersion: editorVersion,
            contentId: contentId,
            noContextPath: true
        }) : baseLink + webuiLink;
    }, [
        editorVersion,
        spaceKey,
        contentType,
        contentId,
        baseLink,
        webuiLink
    ]);
    const emojiId = data?.singleContent?.properties?.nodes?.find((prop)=>prop?.key === 'emoji-title-published')?.value;
    const subType = data?.singleContent?.subType;
    return (0, $42omo.useMemo)(()=>({
            contentId: contentId,
            contentType: contentType,
            subType: subType,
            spaceKey: spaceKey,
            title: title,
            author: contentAvatarName,
            avatarUrl: contentAvatarUrl,
            supportingContent: [],
            mainContentLink: mainContentLink,
            emojiId: emojiId
        }), [
        contentId,
        contentType,
        subType,
        spaceKey,
        title,
        contentAvatarName,
        contentAvatarUrl,
        emojiId,
        mainContentLink
    ]);
};
module.exports["useActiveContent"] = $aa7b9d34cae35fec$export$73b9d3ccb27217c5;

});

parcelRegister("huWyw", function(module, exports) {

var $jlIaF = parcelRequire("jlIaF");

const $61f50eb1c9d5c417$export$35f6369946b1d8c9 = ({ url: url, spaceKey: spaceKey, contentType: contentType, editorVersion: editorVersion, contentId: contentId, fabricEditorSupported: fabricEditorSupported, noContextPath: noContextPath })=>{
    const isPage = contentType === 'page';
    const isBlog = contentType === 'blogpost';
    const isPageOrBlog = isPage || isBlog;
    const isUsingFabricEditor = fabricEditorSupported || editorVersion === 'v2'; // as opposed to the v1 TinyMCE editor
    const providedURLHitsResumeDraftAction = url.includes('resumedraft.action');
    if (isPageOrBlog && isUsingFabricEditor && providedURLHitsResumeDraftAction) {
        const contentTypeForURL = isPage ? 'pages' : 'blog';
        const contentIdForURL = contentId;
        // Extract the query string from the relative URL.
        const queryString = url.includes('?') ? url.slice(url.indexOf('?') + 1) : '';
        // Extract the `draftShareId` from the query string.
        const urlSearchParams = new URLSearchParams(queryString);
        const draftShareId = urlSearchParams.get('draftShareId');
        const draftShareIdParamString = draftShareId ? `draftShareId=${draftShareId}` : '';
        const optionalContextPath = noContextPath ? '' : (0, $jlIaF.CONTEXT_PATH);
        const bypassURL = `${optionalContextPath}/spaces/${spaceKey}/${contentTypeForURL}/edit-v2/${contentIdForURL}?${draftShareIdParamString}`;
        return bypassURL;
    } else return url;
};
module.exports["getURLBypassingResumeDraftAction"] = $61f50eb1c9d5c417$export$35f6369946b1d8c9;

});

parcelRegister("dczXc", function(module, exports) {

var $gad6U = parcelRequire("gad6U");


var $jMyy4 = parcelRequire("jMyy4");

const $3c13baa67eef749f$var$AudioContentQuery = (0, $gad6U.default);
const $3c13baa67eef749f$export$324eefbe48f2a9cf = ({ contentId: contentId })=>{
    const { data: data } = (0, $jMyy4.useQueryInterop)($3c13baa67eef749f$var$AudioContentQuery, {
        variables: {
            contentId: contentId
        },
        skip: !contentId,
        fetchPolicy: 'cache-first'
    });
    return {
        data: data
    };
};
module.exports["useAudioContentQuery"] = $3c13baa67eef749f$export$324eefbe48f2a9cf;

});

parcelRegister("gad6U", function(module, exports) {
/**
 * @generated SignedSource<<d66bc3c1721b856aa5cb4b75929a3d59>>
 * @relayHash 05121d91dabaeb1256fcb9012d73ba65
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c83d09eb0de6a3bf710d7364431c8200591175f07d8ff8317f01a5255ea13554
const $ad449ae2ccc67b2c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "title"
    }, v4 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v5 = {
        "kind": "ScalarField",
        "name": "value"
    }, v6 = {
        "alias": "emoji",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v2 /*: any*/ ,
                    v5 /*: any*/ 
                ]
            }
        ],
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v8 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v9 = [
        v7 /*: any*/ ,
        v8 /*: any*/ 
    ], v10 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "base"
            }
        ]
    }, v11 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published",
                    "editor"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    }
                ]
            }
        ],
        "storageKey": "properties(keys:[\"emoji-title-published\",\"editor\"])"
    }, v12 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        v7 /*: any*/ ,
        v8 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAudioContentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v9 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v9 /*: any*/ 
                                }
                            ]
                        },
                        v10 /*: any*/ ,
                        v11 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAudioContentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v12 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v12 /*: any*/ 
                                }
                            ]
                        },
                        v10 /*: any*/ ,
                        v11 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "05121d91dabaeb1256fcb9012d73ba65",
            "id": "c83d09eb0de6a3bf710d7364431c8200591175f07d8ff8317f01a5255ea13554",
            "metadata": {},
            "name": "useAudioContentQuery",
            "operationKind": "query",
            "text": "query useAudioContentQuery($contentId:ID!){singleContent(id:$contentId){id,title,subType,emoji:properties(key:\"emoji-title-published\"){nodes{id,value}},history{createdBy{__typename,displayName,profilePicture{path}},ownedBy{__typename,displayName,profilePicture{path}}},links{webui,base},properties(keys:[\"emoji-title-published\",\"editor\"]){nodes{value,key}}}}"
        }
    };
}();
$ad449ae2ccc67b2c$var$node.hash = "a697f593a36975591a0fa8257ca3e174";
var $ad449ae2ccc67b2c$export$2e2bcd8739ae039 = $ad449ae2ccc67b2c$var$node;
module.exports["default"] = $ad449ae2ccc67b2c$export$2e2bcd8739ae039;

});

parcelRegister("dWpd3", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $eb4732679a1ccd43$var$initialState = {
    activeContent: null,
    eligibleForChangeboarding: false
};
const $eb4732679a1ccd43$var$actions = {
    setActiveContent: (activeContent)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            return setState({
                ...state,
                activeContent: activeContent
            });
        },
    setEligibleForChangeboarding: (eligibleForChangeboarding)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            return setState({
                ...state,
                eligibleForChangeboarding: eligibleForChangeboarding
            });
        }
};
const $eb4732679a1ccd43$var$AudioButtonWrapperStore = (0, $1P1Tu.createStore)({
    name: 'AudioButtonWrapperStore',
    initialState: $eb4732679a1ccd43$var$initialState,
    actions: $eb4732679a1ccd43$var$actions
});
const $eb4732679a1ccd43$export$ab1ee966cd621cb0 = (0, $9zUhf.createStateHook)($eb4732679a1ccd43$var$AudioButtonWrapperStore, {
    selector: (state)=>({
            activeContent: state.activeContent,
            eligibleForChangeboarding: state.eligibleForChangeboarding
        })
});
const $eb4732679a1ccd43$export$9980b31ff728dec1 = (0, $9zUhf.createActionsHook)($eb4732679a1ccd43$var$AudioButtonWrapperStore);
module.exports["useAudioButtonWrapperStore"] = $eb4732679a1ccd43$export$ab1ee966cd621cb0;
module.exports["useAudioButtonWrapperActions"] = $eb4732679a1ccd43$export$9980b31ff728dec1;

});


//# sourceMappingURL=ListenByline.e750476f.js.map
